export default __webpack_public_path__ + "static/media/11-55.211efbd9.png";